import routesByName from 'constants/routes';

export interface IRoute {
  title: string;
  route: (id?: string) => string;
}

export const detailNavsPrivate: IRoute[] = [
  {
    title: 'app.settings',
    route: routesByName.apps.detail.index,
  },
  {
    title: 'distribution',
    route: routesByName.apps.detail.distribution,
  }, // because of paid apps for private apps
  {
    title: 'app.tab.pricing',
    route: routesByName.apps.detail.pricing,
  }, // because of paid apps for private apps
  {
    title: 'webhooks',
    route: routesByName.apps.detail.webhooks,
  },
  {
    title: 'logs',
    route: routesByName.apps.detail.webhookLogs,
  },
];

export const detailNavsPublic: IRoute[] = [
  {
    title: 'app.settings',
    route: routesByName.apps.detail.index,
  },
  {
    title: 'distribution',
    route: routesByName.apps.detail.distribution,
  },
  {
    title: 'app.tab.pricing',
    route: routesByName.apps.detail.pricing,
  },
  {
    title: 'webhooks',
    route: routesByName.apps.detail.webhooks,
  },
  {
    title: 'logs',
    route: routesByName.apps.detail.webhookLogs,
  },
];
